const BACKEND_URL = process.env['GATSBY_BACKEND_URL'];
const GOOGLE_MAPS_KEY = process.env['GATSBY_GOOGLE_MAPS_KEY'];

export { BACKEND_URL, GOOGLE_MAPS_KEY };
